module.exports = __webpack_public_path__ + "img/gagc4680_2.d4221ba6.svg";